// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {TreeView} from '@material-ui/lab';
import KeyboardArrowRightRoundedIcon from '@material-ui/icons/KeyboardArrowRightRounded';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import {InputLabel} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

// Components
import FolderTreeItem from './folder-tree-item';

const useStyles = makeStyles(theme => ({
  label: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(4),
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 20,
  },
  tree: {
    marginLeft: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
}));

const FolderTree = ({label, onClick, folderData}) => {
  const classes = useStyles();

  const children =
    folderData && folderData.length
      ? new Set(folderData.flatMap(({subFolders}) => subFolders).map(({folderID}) => folderID))
      : new Set();

  const renderTree = (folder, parentFolders) => {
    const {folderID: folderId, subFolders = [], name} = folder;

    return (
      <FolderTreeItem
        folderData={folder}
        key={folderId}
        label={name}
        parentFolderData={parentFolders}
        onClick={onClick}
      >
        {subFolders && subFolders.length
          ? subFolders.map(child => renderTree(child, [...parentFolders, {folderID: folderId, name}]))
          : undefined}
      </FolderTreeItem>
    );
  };

  return folderData && folderData.length ? (
    <>
      <InputLabel className={classes.label}>{label}</InputLabel>
      <TreeView
        className={classes.tree}
        defaultCollapseIcon={<KeyboardArrowDownRoundedIcon />}
        defaultEndIcon={<div style={{width: 24}} />}
        defaultExpandIcon={<KeyboardArrowRightRoundedIcon />}
        defaultExpanded={[]}
        onNodeToggle={e => e.preventDefault()}
      >
        {folderData.filter(({folderID}) => !children.has(folderID)).map(folder => renderTree(folder, []))}
      </TreeView>
    </>
  ) : null;
};

FolderTree.propTypes = {
  folderData: PropTypes.array,
  label: PropTypes.string,
  onClick: PropTypes.func,
};

export default FolderTree;
